import { ReactElement } from 'react';
import appLogo from '../assets/images/app-logo.png';
import appStore from '../assets/images/app-store.png';
import googlePlay from '../assets/images/google-play.png';
import styles from './download-app.module.scss';
import { UIText } from '@/ui';
import { useCommonTranslation } from '../hooks';

export function DownloadApp(): ReactElement {
    const { t } = useCommonTranslation();

    return (
        <div className={styles.container}>
            <img
                src={appLogo}
                alt={'Safepoint App'}
                className={styles.appLogo}
            />

            <UIText variant="h2" medium>
                {t('components.download_app.tagline')}
            </UIText>

            <div className={styles.appstoreContainer}>
                <img
                    src={appStore}
                    alt={t('components.download_app.app_store_alt')}
                    className={styles.appstoreImage}
                />
                <img
                    src={googlePlay}
                    alt={t('components.download_app.google_play_alt')}
                    className={styles.appstoreImage}
                />
            </div>
        </div>
    );
}
